import fetchApi from "../fetchApi";

export const ValidateCardRange = async (
    {office_id, start_processor_reference, end_processor_reference}
) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow',
        body: JSON.stringify({
            office_id: office_id,
            start_processor_reference: start_processor_reference,
            end_processor_reference: end_processor_reference
        })
    }

    return await fetchApi(`card-issuing/sell-order/validate-card-range`, options);
}